import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "line",
  "use": "line-usage",
  "viewBox": "0 0 4 42",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 4 42\" fill=\"none\" id=\"line\"><path id=\"line_矩形 10\" fill-rule=\"evenodd\" style=\"fill:#1D7045\" transform=\"translate(0 0)  rotate(0 2 21)\" opacity=\"1\" d=\"M0,42L4,42L4,0L0,0L0,42Z \" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/line.svg
// module id = 9xjd
// module chunks = 21